module.exports = __webpack_public_path__ + "static/media/IMG-20181013-WA0001.ca25bd36.jpg";